var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import qs from 'qs';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { fetchPizzas } from '../../slices/pizzasSlice';
import Pizza from '../../components/Pizza';
import PizzaLoader from '../../components/loaders/Pizza';
import Sort from '../../components/Sort';
import Categories from '../../components/Categories';
import Pagination from '../../components/Pagination';
import { setFilters } from '../../slices/filtersSlice';
const Home = () => {
    const location = useLocation();
    const { items, status } = useSelector((state) => state.pizzas);
    const [, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const { sort, categoryId, currentPage, searchValue } = useSelector((state) => state.filters);
    const [isFirstRender, setIsFirstRender] = React.useState(false);
    const isMounted = React.useRef(false);
    const pageCount = 3; // it must be from backend
    const getPizzas = () => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(
        // @ts-ignore
        fetchPizzas({
            sort,
            categoryId,
            currentPage,
            searchValue,
        }));
    });
    const renderContent = (stat) => {
        switch (stat) {
            case 'loading': return [1, 2, 3, 4, 5, 6].map((item) => _jsx(PizzaLoader, {}, item));
            case 'success': return items.map((item) => _jsx(Pizza, Object.assign({}, item), item.id));
            case 'error': return _jsx("div", { children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438." });
            default:
                return (_jsx("div", { children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438." }));
        }
    };
    React.useEffect(() => {
        window.scrollTo(0, 0);
        if (isMounted.current) {
            const queryString = qs.stringify({
                categoryId,
                sort: sort.type,
                currentPage,
            });
            setSearchParams(queryString, { replace: true });
        }
        isMounted.current = true;
    }, [categoryId, sort, searchValue, currentPage]);
    React.useEffect(() => {
        if (location.search) {
            const params = qs.parse(location.search.substring(1));
            dispatch(setFilters({
                categoryId: Number(params.categoryId),
                sort: params.sort || sort,
                currentPage: Number(params.currentPage),
                searchValue: params.searchValue,
            }));
            setIsFirstRender(true);
        }
    }, []);
    React.useEffect(() => {
        window.scrollTo(0, 0);
        if (!isFirstRender) {
            getPizzas();
        }
        setIsFirstRender(false);
    }, [categoryId, sort, searchValue, currentPage]);
    return (_jsxs("div", Object.assign({ className: "container" }, { children: [_jsxs("div", Object.assign({ className: "content__top" }, { children: [_jsx(Categories, {}), _jsx(Sort, Object.assign({}, sort))] })), _jsx("h2", Object.assign({ className: "content__title" }, { children: "\u0412\u0441\u0435 \u043F\u0438\u0446\u0446\u044B" })), _jsx("div", Object.assign({ className: "content__items" }, { children: renderContent(status) })), _jsx(Pagination, { pageCount: pageCount })] })));
};
export default Home;
